import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { clearReduxStoreAction } from "../../../../appRedux/reducers/Common";
import CustomButton from "../../CustomButton";
import { LocalStorageConstants } from "../../../../constants/ApplicationConstants/LocalStorageConstants";
import { APPMODE, RouteConstants } from "../../../../constants/ApplicationConstants/RouteConstants";

const Error400 = () => {
  /* CONSTANT */
  const errorMessage = localStorage.getItem(LocalStorageConstants.ERROR_MESSAGE);
  const APP_MODE = process.env.REACT_APP_MODE;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    localStorage.clear();
    dispatch(clearReduxStoreAction());
    navigate(RouteConstants.ROOT_PAGE);
  };

  return (
    <div className="gx-page-error-container">
      <div className="gx-page-error-content">
        <h1 className="gx-text-center gx-mb-4">ERR-FRONTEND-UNHANDLED-EXCEPTION</h1>
        <h4 className="gx-text-center gx-mb-4">We are sorry an unexpected error occurred.</h4>
        {APP_MODE === APPMODE.DEVELOPMENT && <h5 className="gx-text-center gx-mb-4"> {errorMessage}</h5>}
        <p className="gx-text-center">
          <CustomButton text="Go to home" onClick={handleClick} />
        </p>
      </div>
    </div>
  );
};

export default Error400;
